<wk-icon-users-sprite-pds3 />
<icon-pds3 name="wk-icon-users" />
@if (cardModalService.currentCard()?.groupName) {
    <span class="wk-cm__header__icon-text">
        {{ cardModalService.currentCard()?.groupName | truncate: 10 }}
        @if (cardModalService.currentCard()?.groupName?.length > 20) {
            <tooltip-pds3
                position="bottom"
                mode="indicator"
                [openDelay]="600"
                [closeDelay]="50"
                targetSelector=".wk-cm__header__icon-users .wk-cm__header__icon-text"
            >
                {{ cardModalService.currentCard()?.groupName }}
            </tooltip-pds3>
        }
    </span>
}

<tooltip-pds3 position="bottom" mode="description" [openDelay]="600" [closeDelay]="50" targetSelector=".wk-cm__header__icon-users icon-pds3">
    {{ "CardModal.Group" | translate }}
</tooltip-pds3>
